import { STORE_STREET_PARKING_INFO } from "./streetParkingInfoReducer"

export const storeStreetParkingInfo = (streetParkingTime, streetParkingCost, streetParkingCostAllTime) => ({
    type: STORE_STREET_PARKING_INFO,
    payload: {
        streetParkingTime: streetParkingTime,
        streetParkingCost: streetParkingCost,
        streetParkingCostAllTime: streetParkingCostAllTime
    }
})